import React, { Component, lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import i18n from "./Utils/i18next";
import { I18nextProvider } from "react-i18next";
import ReactGA from 'react-ga';
import { naviagateToLogin } from "./Utils/Auth";
import { get } from "./Utils/WebService";
import { API_BASE, BASE_URL_ADMIN, BASE_URL_PREFERENCES, BASE_URL_REPORTS, BASE_URL_UI, ECHO_URL } from "../src/config"
import { store } from ".";
import { setUrlUtils } from "./ui/UrlParameters/UrlParametersAction";
import Cookies from "js-cookie";

import "antd/dist/antd.css";
import "../src/ui/css/bootstrap.min.css"

import "../src/ui/css/main.css";
import "../src/ui/css/main-responsive.css";
import "../src/ui/css/lightTheme.css";

import "../src/ui/lib/fontawesome/css/fontawesome.css";
import "../src/ui/lib/fontawesome/css/all.min.css";
import "../src/ui/lib/owlcarousel/css/owl.carousel.min.css";
import "../src/ui/lib/owlcarousel/css/owl.theme.default.min.css";
import SplashScreen from "./ui/SplashScreen/SplashScreen";


const LandingPage = lazy(() => import("./ui/LandingPage/LandingPage"));
const UserEntrance = lazy(() => import("./ui/UserEntrance/UserEntrance"));
const Dashboard = lazy(() => import("./ui/Dashboard/Dashboard"));
const Preferences = lazy(() => import("./ui/Preferences/Preferences"));

class VispeahenApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isThemePulled: false,
    }
  }

  componentDidMount() {
    let pathName = window.location.href
    let isPathIncludeLogin = pathName.includes(`${BASE_URL_UI}/login`) ? true : false
    let isPathIncludeRegister = pathName.includes(`${BASE_URL_UI}/register`) ? true : false
    let isPathIncludeForgotPassword = pathName.includes(`${BASE_URL_UI}/forgotPassword`) ? true : false
    let mustNavigate = !isPathIncludeForgotPassword && !isPathIncludeLogin && !isPathIncludeRegister ? true : false

    this.applyFavicon()
    this.applyWebsiteTitle()

    store.dispatch(setUrlUtils())

    sessionStorage.removeItem("currentSlider");

    this.setState({
      mustNavigate: mustNavigate
    })

    window.addEventListener("popstate", () => {
      window.location.reload();
    });

    /*
    * Sets target path to session storage for when user login, navigate this path
    */
    const setPathName = () => {
      if (mustNavigate) {
        let pathName = window.location.pathname;
        let search = window.location.search;
        let targetLocation = pathName + search;

        sessionStorage.setItem("targetLocation", targetLocation);
      }
    }

    /*
    * Controls is user authenticate and is user's authentication id is valid
    */
    const controlIsUserAuthenticate = () => {
      let url = ECHO_URL

      const succesFunc = () => {
        this.setState({
          isAuthenticated: true,
        }, () => {
          this.getAndApplyTheme();
        })
      }

      const errorFunc = () => {
        setPathName()
        naviagateToLogin()
      }

      get(url, succesFunc, errorFunc)
    }


    if (mustNavigate) {
      controlIsUserAuthenticate();
    }

    ReactGA.initialize('UA-135650457-2');
    ReactGA.pageview(window.location.pathname);
  }

  applyFavicon = () => {
    const customizationCookie = Cookies.get("loginCustomization");
    if (!customizationCookie) {
      return;
    }
    const customizationObj = JSON.parse(customizationCookie);

    const resourceURL = `/resource/api/resource/unsecured/`;
    const savedFavicon = customizationObj.faviconId ? resourceURL + customizationObj.faviconId : null;

    const defaultFavicon = `${process.env.PUBLIC_URL}/favicon.ico`;

    let link = document.querySelector("link[rel='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    const faviconToUse = savedFavicon || defaultFavicon;

    link.href = `${faviconToUse}?v=${Date.now()}`;
  };

  applyWebsiteTitle = () => {
    const customizationCookie = Cookies.get("loginCustomization");
    if (!customizationCookie) {
      return;
    }
    const customizationObj = JSON.parse(customizationCookie);

    const savedTitle = customizationObj.websiteTitle;

    const defaultTitle = "Vispeahen";

    const titleToUse = savedTitle || defaultTitle;

    document.title = titleToUse;
  };


  /**
   * Get advanced themes of tenant
   */
  getAndApplyTheme = () => {
    let url = `${API_BASE}/theme`;

    const success = (response) => {
      let reduxState = store.getState()
      let themeList = response.data;
      let themes = themeList;
      let hasUrlTheme = reduxState.UrlParametersReducer.urlUtils.has("theme") ? reduxState.UrlParametersReducer.urlUtils.get("theme") : false

      let theme = themes?.find(t => hasUrlTheme ? t._id === hasUrlTheme : t.default === true);

      if (themes?.length > 0) {
        for (let theme of themes) {
          if (typeof theme.plugin?.titleFontSize !== "undefined") {
            theme.plugin.changedTitleFontSize = theme.plugin.titleFontSize;
          }
        }

        sessionStorage.setItem("themes", JSON.stringify(themes));
      }

      if (theme) {
        sessionStorage.setItem("theme-default", JSON.stringify(theme));
      }

      this.setState({
        isThemePulled: true,
      });
    }

    const error = (err) => {
      this.setState({
        isThemePulled: true
      });
    }

    sessionStorage.removeItem("themes");
    sessionStorage.removeItem("theme-default");
    sessionStorage.removeItem("theme-dashboard");

    get(url, success, error);
  }

  refreshCustomization = () => {
    this.applyFavicon();
    this.applyWebsiteTitle();
  };

  render() {
    const { isThemePulled, isAuthenticated, mustNavigate } = this.state;
    const isAppReady = (isThemePulled && isAuthenticated) || !mustNavigate;

    return (
      <I18nextProvider i18n={i18n}>
        <SplashScreen />
        {
          isAppReady && (
            <Suspense fallback={<div></div>}>
              <Switch>
                <Route exact path={BASE_URL_UI} render={(props) => <LandingPage {...props} />} />
                <Route path={`${BASE_URL_UI}/dashboard/:id`} render={(props) => <Dashboard {...props} />} />
                <Route path={`${BASE_URL_UI}/dashboard`} render={(props) => <Dashboard {...props} />} />
                <Route exact path={`${BASE_URL_UI}/login`} render={(props) => !isAuthenticated ? <UserEntrance {...props} onCustomizationChange={this.refreshCustomization} /> : <Dashboard {...props} />} />
                <Route exact path="/ui/register/:activationCode" render={(props) => <UserEntrance {...props} onCustomizationChange={this.refreshCustomization} />} />
                <Route exact path="/ui/forgotPassword/:passwordCode" render={(props) => <UserEntrance {...props} onCustomizationChange={this.refreshCustomization} />} />
                <Route path={BASE_URL_ADMIN} />
                <Route path={BASE_URL_PREFERENCES} render={(props) => <Preferences {...props} />} />
                <Route path={`${BASE_URL_REPORTS}/designer/:id`} />
                <Route path={`${BASE_URL_REPORTS}/designer`} />
              </Switch>
            </Suspense>
          )
        }
      </I18nextProvider>
    );
  }
}

export default VispeahenApp;
